import { languages } from "./languages";

export default {
  0: {
    name: languages.structure.fase + " " + 1,
    started: true
  }
};
